export enum ContactSubjectEnum {
    ChangeMyData = 'GWYZ', // Gegevens wijzigen
    EmailContact = 'ECNT', // E-mail/contact
    Sales = 'AFSL', // Afsluiten
    ReportDamage = 'SMLD', // Schademelden
    ClaimHandling = 'SAFH', // Schadeafhandeling
}


